import { z } from "zod";

z.setErrorMap((issue) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if ((issue as any).received === "nan") return { message: "Informe um número válido." };
      if ((issue as any).received === "undefined" || (issue as any).received === "null")
        return { message: "Campo obrigatório." };
      return { message: "Valor inválido." };

    case z.ZodIssueCode.too_small:
      if ((issue as any).type === "number")
        return { message: `Valor mínimo permitido: ${(issue as any).minimum}.` };
      if ((issue as any).type === "string") {
        const min = (issue as any).minimum as number;
        return { message: `Mínimo de ${min} caractere${min === 1 ? "" : "s"}.` };
      }
      return { message: `Valor mínimo: ${(issue as any).minimum}.` };

    case z.ZodIssueCode.too_big:
      if ((issue as any).type === "number")
        return { message: `Valor máximo permitido: ${(issue as any).maximum}.` };
      if ((issue as any).type === "string") {
        const max = (issue as any).maximum as number;
        return { message: `Máximo de ${max} caractere${max === 1 ? "" : "s"}.` };
      }
      return { message: `Máximo: ${(issue as any).maximum}.` };

    case z.ZodIssueCode.invalid_format:
      if ((issue as any).format === "email") return { message: "E-mail inválido." };
      if ((issue as any).format === "url") return { message: "URL inválida." };
      if ((issue as any).format === "uuid") return { message: "Identificador inválido." };
      if ((issue as any).format === "regex") return { message: "Formato inválido." };
      return { message: "Texto inválido." };

    case z.ZodIssueCode.invalid_value:
      return { message: "Opção inválida." };

    case z.ZodIssueCode.custom:
      return { message: issue.message ?? "Valor inválido." };

    default:
      return { message: issue.message ?? "Valor inválido." };
  }
});
